import { render, staticRenderFns } from "./PromotionAcc.vue?vue&type=template&id=2a82bffa&scoped=true&"
import script from "./PromotionAcc.vue?vue&type=script&lang=js&"
export * from "./PromotionAcc.vue?vue&type=script&lang=js&"
import style0 from "./PromotionAcc.vue?vue&type=style&index=0&id=2a82bffa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a82bffa",
  null
  
)

export default component.exports